import {
  type GatewayId,
  type VerseEnv,
  gatewayIdForVerseEnv,
  gatewayUrlOf,
} from '@rb/shared/admin-verses';

/**
 * 마스터데이터 시딩 연결 URL.
 * - seedUrl: 항상 대상 env 의 gateway (현재 토글된/override gateway 무시).
 * - restoreUrl: 시딩 진입 전 유효 gateway (복원용).
 */
export function seedConnectionUrls(
  verseEnv: VerseEnv,
  effectiveGatewayId: GatewayId
): { seedUrl: string; restoreUrl: string } {
  return {
    seedUrl: gatewayUrlOf(gatewayIdForVerseEnv(verseEnv)),
    restoreUrl: gatewayUrlOf(effectiveGatewayId),
  };
}
